export default __webpack_public_path__ + "static/media/P942_CoC.1c4a422d.pdf";